export default {
	methods: {
		getControleAnuencia() {
			let hash = this.$route.params.hash
			return Number(this.convertBase64ToString(hash))
		},
		convertBase64ToString(base64) {
			return atob(base64)
		},
	},
}
